import React, { useMemo, useRef } from "react";
import { Field } from "react-final-form";
import SignatureCanvas from "react-signature-canvas";

import RffInputWrapper from "../shared/RffInputWrapper";
import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";
import { Box, Button, FormHelperText } from "@mui/material";
import { grey } from "@mui/material/colors";
import Flx from "../../layout/Flx";

// const RffSignatureField = ({
//   name,
//   label,
//   required,
//   suppressGrid,
//   size,
//   sx,
//   // Optionally pass props for customizing the signature canvas
//   canvasProps = { width: "100%", height: "210px", className: "sigCanvas" },
// }) => {
//   const signatureRef = useRef(null);

//   // If required, use the existing validator
//   const validate = useMemo(
//     () => (required ? VALIDATOR_REQUIRE : undefined),
//     [required]
//   );

//   return (
//     <RffInputWrapper
//       label={label}
//       suppressGrid={suppressGrid}
//       size={size}
//       required={required}
//     >
//       <Field
//         name={name}
//         validate={validate}
//         subscription={{ value: true, error: true, touched: true }}
//         render={({ input, meta }) => {
//           // Normal function defined in the render scope (no Hooks).
//           function handleEnd() {
//             if (!signatureRef.current) return;

//             try {
//               // Try "trimmed" version
//               const trimmedCanvas = signatureRef.current.getTrimmedCanvas();
//               input.onChange(trimmedCanvas.toDataURL("image/png"));
//             } catch (error) {
//               // Fallback to getCanvas if getTrimmedCanvas() isn't supported
//               const rawCanvas = signatureRef.current.getCanvas();
//               input.onChange(rawCanvas.toDataURL("image/png"));
//             }
//           }

//           function clearSignature() {
//             if (!signatureRef.current) return;
//             signatureRef.current.clear();
//             input.onChange(null); // Clear form value
//           }

//           return (
//             <Flx column>
//               <Box
//                 sx={{
//                   border: `1px solid ${grey[300]}`,
//                   borderRadius: "4px",
//                   canvas: {
//                     width: "100%",
//                     height: canvasProps.height,
//                   },
//                 }}
//               >
//                 {/* Signature pad area */}
//                 <SignatureCanvas
//                   ref={signatureRef}
//                   penColor="black"
//                   onEnd={handleEnd}
//                   {...canvasProps}
//                   style={sx}
//                 />

//                 {/* Clear button */}

//                 {/* Display the saved signature from form state (if any) */}
//                 {/* {input.value && <SignaturePreview src={input.value} />} */}
//               </Box>
//               {input.value ? (
//                 <Flx column>
//                   <Button variant="text" onClick={clearSignature}>
//                     Clear Signature
//                   </Button>
//                 </Flx>
//               ) : null}

//               {/* Final Form error handling */}
//               {meta.touched && meta.error && (
//                 <FormHelperText sx={{ ml: 3 }} error>
//                   {meta.error}
//                 </FormHelperText>
//               )}
//             </Flx>
//           );
//         }}
//       />
//     </RffInputWrapper>
//   );
// };
const RffSignatureField = ({
  name,
  label,
  required,
  suppressGrid,
  size,
  sx,
  canvasProps = { width: "100%", height: "210px", className: "sigCanvas" },
}) => {
  const signatureRef = useRef(null);

  const validate = useMemo(
    () =>
      required
        ? (value) => {
            if (!value || value === "") return "Required";
            return undefined;
          }
        : undefined,
    [required],
  );

  return (
    <RffInputWrapper
      label={label}
      suppressGrid={suppressGrid}
      size={size}
      required={required}
    >
      <Field
        name={name}
        validate={validate}
        // Add submitFailed so error shows after a submit attempt
        subscription={{
          value: true,
          error: true,
          touched: true,
          submitFailed: true,
        }}
        render={({ input, meta }) => {
          function handleEnd() {
            if (!signatureRef.current) return;
            try {
              const trimmedCanvas = signatureRef.current.getTrimmedCanvas();
              input.onChange(trimmedCanvas.toDataURL("image/png"));
            } catch (error) {
              const rawCanvas = signatureRef.current.getCanvas();
              input.onChange(rawCanvas.toDataURL("image/png"));
            }
            // Mark as touched so validation messages can appear
            input.onBlur();
          }

          function clearSignature() {
            if (!signatureRef.current) return;
            signatureRef.current.clear();
            input.onChange(null);
            input.onBlur();
          }

          // Show error if touched OR if a submit was attempted
          const showError = meta.error && (meta.touched || meta.submitFailed);

          return (
            <Flx column>
              <Box
                sx={{
                  border: `1px solid ${showError ? "#d32f2f" : grey[300]}`,
                  borderRadius: "4px",
                  canvas: {
                    width: "100%",
                    height: canvasProps.height,
                  },
                }}
              >
                <SignatureCanvas
                  ref={signatureRef}
                  penColor="black"
                  onEnd={handleEnd}
                  onBegin={() => input.onFocus()}
                  {...canvasProps}
                  style={sx}
                />
              </Box>
              {input.value ? (
                <Flx column>
                  <Button variant="text" onClick={clearSignature}>
                    Clear Signature
                  </Button>
                </Flx>
              ) : null}

              {showError && (
                <FormHelperText sx={{ ml: 3 }} error>
                  {meta.error}
                </FormHelperText>
              )}
            </Flx>
          );
        }}
      />
    </RffInputWrapper>
  );
};

export default RffSignatureField;
